import {Injectable} from "@angular/core";
import {Tag} from "../model/tag";

@Injectable({
  providedIn: 'root'
})
export class ClassService {

  getIconClass(tag: Tag) {
    if (tag.free && !tag.special) {
      return "free-icon"
    } else if (tag.special) {
      switch(tag.id) {
        case 77: return "feb14-icon";
        case 391: return "feb23-icon";
        case 68: return "mar8-icon";
        case 36: return "ny-icon";
        case 82: return "may9-icon";

      }
    }
    return undefined;
  }
}
